import InputAdornment from '@mui/material/InputAdornment';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import { grey2 } from 'react/shared/theme/palette';
import { pressedEnterOrSpaceButton } from 'react/shared/utils/KeyboardEvents';

const useStyles = makeStyles(() => ({
  adornment: {
    color: grey2,
    cursor: 'pointer',
    fontSize: '18px',
  },
}));

export default function PasswordAdornment({ onClick, showPassword }) {
  const classes = useStyles();

  const handleKeyDown = (ev) => {
    if (pressedEnterOrSpaceButton(ev)) {
      ev.preventDefault();
      onClick();
    }
  };

  return (
    <InputAdornment onClick={onClick} onKeyDown={handleKeyDown} position="end">
      <span className={classes.adornment} role="button" tabIndex="0">
        {showPassword ? 'Hide password' : 'Show password'}
      </span>
    </InputAdornment>
  );
}

PasswordAdornment.propTypes = {
  onClick: PropTypes.func.isRequired,
  showPassword: PropTypes.bool.isRequired,
};
